import { type Context, type FC, createContext, useContext, type ReactNode } from 'react';

export function createRequiredContext<T>(name: string): {
    Provider: FC<{ children: ReactNode; value: T }>;
    hook: () => T;
    Context: Context<T | null>;
} {
    const NewContext = createContext<T | null>(null);

    const Provider = ({ children, value }: { children: ReactNode; value: T }) => (
        <NewContext.Provider value={value}>{children}</NewContext.Provider>
    );

    function useTheProvider() {
        const value = useContext(NewContext);
        if (value === null) {
            throw new Error(`'${name}' provider not found.`);
        }
        return value;
    }

    return {
        Provider,
        hook: useTheProvider,
        // This is generally unnecessary to use the context, but we had some odd
        // implementations with the AngularContext that needed it
        Context: NewContext,
    };
}
